import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ClientSuiteInput from "./ClientSuiteInput";
import SampleInformationInput from "./SampleInformationInput";
import DropDown from "../DropDown";
import { fetchJson } from "../../lib/Fetching";
import styled, { css } from "styled-components";
import classnames from "classnames";
import Button from "../Button";

const Alert = styled.div`
  height: 35px;
  margin: 0px;
  padding: 6px;
  border: 1px solid #ddd;
`;

const Col = styled.div``;

// using CSS grid here
const Form = styled.div`
  padding: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr ${props => props && !props.hideDelete && css`50px`};
  grid-row-gap: 5px;
  grid-column-gap: 5px;
  ${props =>
    props.valid
      ? css`
          background-color: #e8ffe8;
        `
      : css`
          background-color: #ffe8e8;
        `};
`;

export default class IndividualScheduleForm extends React.Component {
  state = {
    client_suite_id: null,
    client_specification_id: null,
    sample_information_id: null,
    client_specifications: [],
    require_specification: false,
    hideDelete: false
  };

  scheduleParameters = () => {
    return {
      client_suite_id: this.state.client_suite_id,
      client_specification_id: this.state.client_specification_id,
      sample_information_id: this.state.sample_information_id
    };
  };

  isValid = () => {
    const {
      client_suite_id,
      client_specification_id,
      require_specification,
      sample_information_id
    } = this.state;
    return (
      sample_information_id &&
      client_suite_id &&
      (!require_specification || client_specification_id)
    );
  };

  sampleInformationChanged = option => {
    const sample_information_id = option.value;
    this.setState({ sample_information_id });
  };

  clientSuiteChanged = option => {
    const client_suite_id = option.value;
    this.setState({ client_suite_id });

    fetchJson(
      "/products/client_suites/" + client_suite_id + "/compatible_specifications.json"
    ).then(json => {
      if (json.no_specification_required) {
        this.setState({ require_specification: false, client_specification_id: null });
      } else {
        this.setState({ client_specifications: json, require_specification: true });
      }
    });
  };

  clientSpecificationChanged = option => {
    const client_specification_id = option.value;
    this.setState({ client_specification_id });
  };

  showSpecification = () => {
    const { require_specification, client_specifications } = this.state;
    return require_specification && client_specifications.length > 0;
  };

  noCompatibleSpecificationsFound = () => {
    const { require_specification, client_specifications, client_suite_id } = this.state;
    return require_specification && client_suite_id && client_specifications.length == 0;
  };

  noSpecificationRequired = () => {
    const { require_specification, client_suite_id } = this.state;
    return !require_specification && client_suite_id;
  };

  render() {
    const { company_id, removeForm, hideDelete } = this.props;
    const { client_specifications, client_suite_id, client_specification_id } = this.state;
    const specificationOptions = client_specifications.map(spec => ({
      value: spec.id,
      label: spec.name
    }));
    return (
      <Form valid={this.isValid()} hideDelete={hideDelete}>
        <Col>
          <SampleInformationInput
            company_id={company_id}
            onChange={this.sampleInformationChanged}
          />
        </Col>
        <Col>
          <ClientSuiteInput
            value={client_suite_id}
            onChange={this.clientSuiteChanged}
            multiple={false}
            company_id={company_id}
          />
        </Col>
        <Col>
          {this.showSpecification() && (
            <DropDown
              options={specificationOptions}
              value={client_specification_id}
              placeholder={"Pick specification"}
              onChange={this.clientSpecificationChanged}
            />
          )}
          {this.noCompatibleSpecificationsFound() && (
            <Alert className={"alert alert-warning"}>No compatible specifications found</Alert>
          )}
          {this.noSpecificationRequired() && (
            <Alert className={"alert alert-info"}>No Specification Required</Alert>
          )}
          {!client_suite_id && <Alert className={"alert alert-default"}>...</Alert>}
        </Col>
        {!hideDelete && (
          <Col>
            <div className="btn-toolbar">
              {removeForm && <Button icon="fa-trash" onClick={removeForm} deleting small />}
            </div>
          </Col>
        )}
      </Form>
    );
  }
}

IndividualScheduleForm.propTypes = {
  company_id: PropTypes.array,
  removeForm: PropTypes.func
};
